export const cssBundleHref = "/build/css-bundle-J5CMNRBF.css";